import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { useSnackbar } from 'notistack';
import Grid from "@mui/material/Grid2";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
function AuthLayout({children,classes}) {
    return (
        <React.Fragment>
            <CssBaseline />
                <div className={classes.authContainer}>
                    {
                        children
                    }

                </div>


        </React.Fragment>
    );
}
export default withStyles(Styles)(AuthLayout);
